function shoppingCartReducer(items = [], action) {
  switch (action.type) {
    case "ADD_ITEM":
      const result = [...items];
      // buscar si el producto que viene ya esta agregado al carrito
      const incommingProduct = action.payload;
      const currentProduct = result.find((e) => e._id === incommingProduct._id);
      // si existe, actualizar cantidad
      if (currentProduct) {
        currentProduct.quantity = incommingProduct.quantity
          ? currentProduct.quantity + incommingProduct.quantity
          : currentProduct.quantity + 1;
      } else {
        // si no exite, agregarlo
        result.push(incommingProduct);
      }
      return result;

    case "DELETE_ITEM":
      return items.filter((item) => item._id !== action.payload._id);

    case "ADD_ITEM_FROM_CART":
      const result2 = [...items];
      const incommingProduct2 = action.payload;
      const currentProduct2 = result2.find((e) => e._id === incommingProduct2);
      if (currentProduct2.quantity < currentProduct2.stock) {
        currentProduct2.quantity = currentProduct2.quantity + 1;
      }
      return result2;

    case "REMOVE_ITEM_FROM_CART":
      const result3 = [...items];
      const incommingProduct3 = action.payload;
      const currentProduct3 = result3.find((e) => e._id === incommingProduct3);
      if (currentProduct3.quantity > 1) {
        currentProduct3.quantity = currentProduct3.quantity - 1;
      }
      return result3;

    case "REMOVE_ITEMS_FROM_CART":
      return [];

    default:
      return items;
  }
}

export default shoppingCartReducer;
